export default __webpack_public_path__ + "static/banner-media-release-oct1-4f910cfe2ac2034ddb3dcdd85dbbab05.jpg";